import { BACKEND_URL } from './config';
import { getAccessToken } from './session';

/* Recherche hybride (lexical + sémantique) sur les items du programme. */
/* CUTOVER (Vague 1) : tape désormais le backend apps/api (embeddings Vertex) → */
/* RPC search_program_items_hybrid, plus la fonction edge semantic-search. */
/* Contrat identique (body { q, target, limit } → { hits, timing_ms }). */
/* Rollback = revert de ce commit. */
const SEARCH_URL = `${BACKEND_URL}/curriculum/search`;

export interface ItemHit {
  id: string;
  content: string;
  kind: string;
  subject: string | null;
  cycle: string | null;
  document_id: string | null;
  document_title: string | null;
  pages: number[] | null;
  score: number;
}

export async function searchProgramItems(q: string, limit = 25): Promise<{ hits: ItemHit[]; ms: number }> {
  const token = await getAccessToken();
  if (!token) throw new Error('Non authentifié');
  const res = await fetch(SEARCH_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ q, target: 'items', limit }),
  });
  if (!res.ok) throw new Error(`curriculum/search ${res.status}: ${(await res.text()).slice(0, 200)}`);
  const j = (await res.json()) as { hits?: ItemHit[]; timing_ms?: { total?: number } };
  return { hits: j.hits ?? [], ms: j.timing_ms?.total ?? 0 };
}
